"use strict";

spreadsheets.classy.controller({
    name: "DownloadReportModalsController",
    inject: ["$scope", "$http", "item", "authServiceFactory", "$modalInstance", "DateService"],
    init: function() {
        this.$.$modalInstance = this.$modalInstance;
        this.$.datearray = [];
        let parent = this;
        this.$http.get("api/school/" + this.authServiceFactory.getAuth().schoolID + "/spreadsheetYears").then(
            (results) => {
                this.$.datearray = results.data;
                parent.$.$apply();
            });
        this.$.downloadform = {
            dl: 1,
            SB: "ALL",
            year: "",
            showNeg: 0
        };
    },
    download: function(instance) {
        let headers = {group: this.$.downloadform.SB, year: this.$.downloadform.year, showNeg: this.$.downloadform.showNeg};
        this.$.loading = true;
        this.$http.get("/api/school/" + this.authServiceFactory.getAuth().schoolID + "/spreadsheet/" + this.item.id, {headers: headers}).success((results) => {
            instance.stop(1);
            let title = this.item.name;
            this.exportToCsv(results, title);
        }).error((results) => {
            instance.stop(-1);
            this.$.loading = false;
        });
    },
    successSave: function(scope, instance) {
        instance.stop(1);
    },
    exportToCsv: function(csv, title) {
        let element = document.createElement("a");
        element.setAttribute("href", "data:attachment/csv;charset=utf-8," + encodeURIComponent(csv));
        element.setAttribute("target", "_blank");
        element.setAttribute("download", title + ".csv");
        document.body.appendChild(element);
        element.click();
        this.$.loading = false;
    }
});
